module.exports = __webpack_public_path__ + "static/mimi-d0be634f103b3e76c07939f1a96b12b5.jpg";